<section id="main-content">
  <div class="" role="main">

    <mat-card class="mat-elevation-z0 banner">
    <div class="row">
      <form [formGroup]="homeForm">
        <mat-form-field class="col-md-6 col-xs-12">
          <mat-label>Empresa</mat-label>
          <mat-select formControlName="empresasId" multiple>
            <mat-option *ngFor="let empresa of empresas" [value]="empresa.empresaId">
              {{empresa.nomeFantasia}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>

      <div class="row tile_count"  *ngIf="exibeFinanceiro">
        <h3>Mês Atual</h3>
        <hr>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <app-info-card
          title="Total Recebido"
          value="{{total.recebido}}"
          valuePrefixo = "R$"
          [progress]="total.receberPrevisto>0 ? (total.recebido/total.receberPrevisto)*100 : 0"
          backgroundIcon="monetization_on"
          footerText="Previsão do mês: {{total.receberPrevisto | currency}}"
          cor="azul"
          ></app-info-card>

        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <app-info-card
          title="Total Pago"
          value="{{total.pago}}"
          valuePrefixo = "R$"
          [progress]="total.pagarPrevisto>0 ? (total.pago/total.pagarPrevisto)*100 : 0"
          backgroundIcon="money_off_csred"
          footerText="Previsão do mês: {{total.pagarPrevisto | currency}}"
          cor="vermelho"
          ></app-info-card>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <app-info-card
          title="Margem de Lucro Líquida"
          value="{{margemRealizada}}"
          valueSufixo = "%"
          valuePrefixo = "{{prefixo}}"
          [progress]="total.margemPrevista>0?(total.margemRealizada/total.margemPrevista)*100:0"
          backgroundIcon="trending_up"
          footerText="Previsão do mês: {{total.margemPrevista | number: '1.2-2'}} %"
          cor="verde" ></app-info-card>
        </div>

      </div>
   </mat-card>
    <div class="row"  *ngIf="exibeFinanceiro">
      <div class="col-md-6">
        <mat-card class="mat-elevation-z0">
          <h3>Fluxo de Caixa</h3>
          <hr>
          <canvas baseChart [datasets]="faturamentoMesChartData" [labels]="faturamentoMesChartLabels"
            [options]="faturamentoMesChartOptions" [legend]="faturamentoMesChartLegend"
            [chartType]="faturamentoMesChartType"></canvas>

        </mat-card>
      </div>
      <div class="col-md-6">
        <mat-card class="mat-elevation-z0">
          <h3>Percentual de Lucro x Despesas</h3>
          <hr>
          <canvas baseChart [datasets]="despesasReceitasChartData" [labels]="despesasReceitasChartLabels"
          [options]="despesasReceitasChartOptions" [legend]="despesasReceitasChartLegend"
          [chartType]="despesasReceitasChartType"></canvas>
        </mat-card>
      </div>

    </div>



  <div class="row"  *ngIf="exibeFinanceiro">
        <div class="col-md-3">
            <app-status-card
            texto="Total a Pagar Previsto"
            cor="vermelho"
            icone="request_quote"
            descricao="{{total.pagarPrevisto | currency}}">
          </app-status-card>
        </div>
        <div class="col-md-3">
          <app-status-card
          texto="Total Pago"
          cor="vermelho"
          icone="task_alt"
          descricao="{{total.pago | currency}}">
        </app-status-card>
        </div>
        <div class="col-md-3">
          <app-status-card
          texto="Total a Receber Previsto"
          cor="azul"
          icone="request_quote"
          descricao="{{total.receberPrevisto | currency}}">
        </app-status-card>
      </div>
      <div class="col-md-3">
        <app-status-card
        texto="Total Recebido"
        cor="azul"
        icone="task_alt"
        descricao="{{total.recebido | currency}}">
      </app-status-card>
      </div>

  </div>

  <div class="row"  *ngIf="exibeFinanceiro">
    <div class="col-md-6" *ngIf="parcelasPagar?.length>0">
      <mat-card class="mat-elevation-z0">
        <h4>Contas a Pagar Hoje</h4>
                    <hr />
                    <table class="table table-striped" cellspacing="0" cellpadding="0">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let parcelaPagar of parcelasPagar">
                          <td>{{parcelaPagar.descricao}}</td>
                          <td>{{parcelaPagar.valorParcela | currency}}</td>
                        </tr>
                      </tbody>
                    </table>
       </mat-card>
    </div>
    <div class="col-md-6" *ngIf="parcelasReceber?.length>0">
      <mat-card class="mat-elevation-z0">
      <h4>Contas a Receber Hoje</h4>
                  <hr />
                  <table class="table table-striped" cellspacing="0" cellpadding="0">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let parcelaReceber of parcelasReceber">
                        <td>{{parcelaReceber.descricao}}</td>
                        <td>{{parcelaReceber.valorParcela | currency}}</td>
                      </tr>
                    </tbody>
                  </table>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6" *ngIf="exibeVenda">
      <mat-card class="mat-elevation-z0">
        <h3>Vendas</h3>
        <hr/>
        <div class="row">
        <div class="col-md-6">
          <app-info-card
          title="Quantidade de Vendas"
          value="{{total.vendas}}"
          [progress]="100-porcentagemVendas"
          backgroundIcon="sell"
          footerText="{{porcentagemVendas | number: '1.2-2'}}% do que o mês anterior"
          footerIcon="{{porcentagemVendas > 0 ? 'arrow_upward': 'arrow_downward'}}"
          cor="amarelo"
          ></app-info-card>
      </div>
      <div class="col-md-6">
        <app-info-card
        title="Faturamento Vendas"
        value="{{total.vendasFaturamento}}"
        valuePrefixo="R$"
        [progress]="100-porcentagemVendasFaturamento"
        backgroundIcon="monetization_on"
        footerText="{{porcentagemVendasFaturamento | number: '1.2-2'}}% do que o mês anterior"
        footerIcon="{{porcentagemVendasFaturamento > 0 ? 'arrow_upward': 'arrow_downward'}}"
        cor="amarelo"
        ></app-info-card>
        </div>
      </div>
      </mat-card>
    </div>
    <div class="col-md-6" *ngIf="exibeCompra">
      <mat-card class="mat-elevation-z0">
        <h3>Compras</h3>
        <hr/>
        <div class="row">
        <div class="col-md-6">
          <app-info-card
          title="Quantidade de Compras"
          value="{{total.compras}}"
          [progress]="100-porcentagemCompras"
          backgroundIcon="sell"
          footerText="{{porcentagemCompras | number: '1.2-2'}}% do que o mês anterior"
          cor="laranja"
          footerIcon="{{porcentagemCompras > 0 ? 'arrow_upward': 'arrow_downward'}}"
          ></app-info-card>
      </div>
      <div class="col-md-6">
        <app-info-card
        title="Faturamento Compras"
        value="{{total.comprasFaturamento}}"
        valuePrefixo="R$"
        [progress]="100-porcentagemComprasFaturamento"
        backgroundIcon="monetization_on"
        footerText="{{porcentagemComprasFaturamento | number: '1.2-2'}}% do que o mês anterior"
        cor="laranja"
        footerIcon="{{porcentagemComprasFaturamento > 0 ? 'arrow_upward': 'arrow_downward'}}"
        ></app-info-card>
        </div>
      </div>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-card class="mat-elevation-z0">
        <div class="row">
          <div class="col-md-6" *ngIf="exibeFinanceiro">
              <h3>Fluxo de Caixa Atual</h3>
            <hr />
            <table class="table table-striped" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <th>Caixa</th>
                  <th>Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let caixa of caixas">
                  <td>{{caixa.nome}}</td>
                  <td>{{caixa.saldo | currency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6" *ngIf="exibeEstoque">
              <h3>Estoques próximos ao mínimo</h3>
            <hr />
            <table class="table table-striped" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <th>Estoque</th>
                  <th>Mínimo</th>
                  <th>Quantidade Atual</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let estoque of estoques">
                  <td>{{estoque.produto.descricao}}</td>
                  <td>{{estoque.minimo}}</td>
                  <td>{{estoque.quantidade}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

</div>
</section>
